module.exports = __webpack_public_path__ + "static/media/itsm.28408009.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/equinixIcon/itsm.svg
// module id = 1112
// module chunks = 49